/**
 * Mirrors company scope fields onto PUT payloads so role-only updates do not wipe assignments
 * (UsersRestController treats missing company_ids as empty list).
 */

import type { User } from '@/users/src/types/user';

export const companyIdsForUserUpdatePayload = (user: User): number[] => {
  if (user.company_ids !== undefined && user.company_ids.length > 0) {
    return [...user.company_ids];
  }
  if (user.companies !== undefined && user.companies.length > 0) {
    return user.companies.map((c) => c.id);
  }
  if (user.company_id !== undefined && user.company_id > 0) {
    return [user.company_id];
  }
  return [];
};
